import { EmptyState, Spinner, BlendxCard } from '@blend-ed/blendx-ui';
import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import { AppContext } from '@edx/frontend-platform/react';
import { useMutation as useReactQueryMutation } from '@tanstack/react-query';
import React, { useContext } from 'react';
import { markAttendance } from '../api/LearnerAttendance';
import messages from './messages';

function CourseTab({ renderCourses, isLoading }) {
    const { authenticatedUser } = useContext(AppContext);

    const markAttendanceMutation = useReactQueryMutation({
        mutationFn: (data) => markAttendance(data.userId, data.courseId)
    });

    if (isLoading) {
        return (
            <div className="blendx-spinner-container">
                <Spinner animation="border" size="lg" variant="dark" />
            </div>
        )
    }

    if (!renderCourses.length) {
        return <EmptyState
            type="box"
            message={<FormattedMessage {...messages.noCoursesFound} />}
            className="course-empty-state"
        />
    }

    return (
        <div className="course-cards-container">
            {renderCourses
                .map((course, index) => {
                    const link = course.courseRun.resumeUrl ? getConfig().LMS_BASE_URL + course.courseRun.resumeUrl : course.courseRun.homeUrl;
                    const homeLink = course.courseRun.homeUrl;
                    const startsFuture = new Date(course.courseRun.startDate) > new Date();
                    const startDateFormatted = new Date(course.courseRun.startDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
                    return (
                        <BlendxCard
                            key={index}
                            title={course.course?.courseName}
                            image={getConfig().LMS_BASE_URL + course.course.bannerImgSrc}
                            type={startsFuture ? "upcoming" : "learning"}
                            startDate={startDateFormatted}
                            variant="course"
                            link={link}
                            homeLink={homeLink}
                            redirect={true}
                            courseId={course.courseRun.courseId}
                            onClick={async () => {
                                await markAttendanceMutation.mutateAsync({
                                    userId: authenticatedUser.id,
                                    courseId: course.courseRun.courseId
                                });
                            }}
                        />
                    )
                })}
        </div>
    )
}

export default CourseTab